import HistoryPointsSection from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistoryPointsSection/HistoryPointsSection';

export default HistoryPointsSection;
